import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export default class SparePartsFinderCheckboxListFilter extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        options: PropTypes.array,
        onChange: PropTypes.func,
        canShowSelectAll: PropTypes.bool
    }

    render() {
        if (!this.props.meta.visible) {
            return <React.Fragment/>
        }

        return (
            <div className="filter-box-container">
                <div className="header">
                    <div className="name">
                        {this.props.meta.name}
                    </div>
                    <div className="options">
                        {!this.props.meta.readonly && this.renderHeaderOptions()}
                    </div>
                </div>
                <div className="body">
                    {!this.props.meta.readonly && this.renderOptions()}
                    {this.props.meta.readonly && this.props.previousFilter !== null && this.renderPreviousFilterEmptyInfo()}
                </div>
            </div>
        )
    }

    renderPreviousFilterEmptyInfo = () => (
        <p className="previous-filter-empty-info">{__('Please select')}<span
            className="filter-name">&nbsp;{this.props.previousFilter.meta.name}&nbsp;</span>{__('to show possible options.')}
        </p>
    )

    renderHeaderOptions = () => (
        <React.Fragment>
            {this.canRenderSelectAllOption() && this.renderHeaderSelectAllOption()}
            {this.canRenderClearOption() && this.renderHeaderClearOption()}
        </React.Fragment>
    )

    renderHeaderSelectAllOption = () => (
        <div className="option select-all" onClick={this.onSelectAllClick}>
            <span>&#10004;</span> <span>{__('Select all')}</span>
        </div>
    )

    renderHeaderClearOption = () => (
        <div className="option clear" onClick={this.onClearClick}>
            <span>&#10006;</span> <span>{__('Clear')}</span>
        </div>
    )

    canRenderSelectAllOption() {
        return this.props.items.length > 0;
    }

    canRenderClearOption() {
        return true;
    }

    renderOptions = () => (
        <ul>
            {this.props.items.map((o, i) => this.renderOption(o, `${this.props.meta.slug}.${i}`))}
        </ul>
    )

    renderOption = (o, i) => (
        <li key={i}>
            <input disabled={this.props.meta.readonly} type="checkbox" id={i} checked={this.isChecked(o)}
                   onChange={() => this.onChange(o.value)}/>
            <label htmlFor={i}>{o.text}</label>
        </li>
    )

    onChange = value => {
    }

    onClearClick = e => {
    }

    onSelectAllClick = e => this.props.onFilterChange(this.props.meta.slug, this.props.items.map(x => x.value))

    isChecked = o => this.props.selectedValues.includes(o.value);
} 